
export const Role = {
  ADMIN: 1
}